export default "__VITE_ASSET__bced2f09__"